// Lazy-load the HubSpot form in the newsletter subscribe block, output by the
// [epic_newsletter_subscribe_form] shortcode. The HubSpot forms script, and the reCAPTCHA
// it loads, are only requested once the form comes within LOAD_MARGIN of the viewport, or
// the visitor interacts with the block, instead of on page load (ANTT #41957).

var HS_FORMS_SCRIPT = 'https://js.hsforms.net/forms/v2.js';
var LOAD_MARGIN = '400px';

var scriptState = 'idle'; // idle, loading, loaded
var scriptCallbacks = [];

// Load the HubSpot forms script once, however many subscribe blocks are on the page.
function loadHubspotScript(callback) {
	if (scriptState === 'loaded' || (window.hbspt && window.hbspt.forms)) {
		scriptState = 'loaded';
		callback();
		return;
	}

	scriptCallbacks.push(callback);
	if (scriptState === 'loading') {
		return;
	}

	scriptState = 'loading';
	var script = document.createElement('script');
	script.src = HS_FORMS_SCRIPT;
	script.charset = 'utf-8';
	script.async = true;
	script.onload = function () {
		scriptState = 'loaded';
		scriptCallbacks.splice(0).forEach(function (cb) {
			cb();
		});
	};
	document.head.appendChild(script);
}

// Same swap the inline embed did with #hideForm and #showThanks, scoped to this block.
function showThanks(target) {
	var body = target.closest('.c-newsletter-subscribe__body');
	if (!body) {
		return;
	}

	var form = body.querySelector('.c-newsletter-subscribe__form');
	var thanks = body.querySelector('.c-newsletter-subscribe__thanks');
	if (form) {
		form.style.display = 'none';
	}
	if (thanks) {
		thanks.style.display = 'block';
	}
}

function createForm(target) {
	if (target.getAttribute('data-form-state')) {
		return;
	}
	target.setAttribute('data-form-state', 'loading');

	var options = JSON.parse(target.getAttribute('data-hs-form'));
	options.target = '#' + target.id;
	options.onFormReady = function () {
		target.setAttribute('data-form-state', 'ready');
	};
	options.onFormSubmit = function () {
		showThanks(target);
	};

	loadHubspotScript(function () {
		window.hbspt.forms.create(options);
	});
}

function init() {
	var targets = document.querySelectorAll('.js-newsletter-subscribe-form');
	if (!targets.length) {
		return;
	}

	if (!('IntersectionObserver' in window)) {
		Array.prototype.forEach.call(targets, createForm);
		return;
	}

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target);
				createForm(entry.target);
			}
		});
	}, { rootMargin: LOAD_MARGIN });

	Array.prototype.forEach.call(targets, function (target) {
		observer.observe(target);

		// Fallback: load as soon as the visitor touches, clicks, or tabs into the block.
		var block = target.closest('.c-newsletter-subscribe');
		if (!block) {
			return;
		}
		var loadNow = function () {
			observer.unobserve(target);
			createForm(target);
		};
		['pointerdown', 'keydown', 'focusin'].forEach(function (type) {
			block.addEventListener(type, loadNow, { once: true });
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
